import React from "react";
import styled from "styled-components";
import { Spin } from "antd";
import loadable from "~/utils/loadable";

const LoadingIndicator = () => (
  <CenteredSpin>
    <Spin />
  </CenteredSpin>
);

const CenteredSpin = styled.div`
  background: rgba(0, 0, 0, 0.05);
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default loadable(() => import("./Main"), {
  fallback: <LoadingIndicator />,
});
